// extracted by mini-css-extract-plugin
export default {"cardMedia":"pT-z","shopText":"qT-z","videoPlayer":"rT-z","videoContainer":"sT-z"};